import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery, toQueryParams } from 'helpers/api';

export const checkTypeApi = createApi({
  reducerPath: 'checkTypeApi',
  baseQuery: createBaseQuery('check_types', { timeout: 0 }),
  endpoints: builder => ({
    getCheckTypes: builder.query({
      query: () => ({ url: '/' }),
      transformResponse: ({ result }) => result ?? [],
    }),
    getCheckTypesList: builder.query({
      query: params => ({
        url: `/list?${toQueryParams(params || {})}`,
        params: {},
      }),
      transformResponse: ({ result }) => result ?? [],
    }),
    getCheckGroups: builder.query({
      query: () => '/check_groups',
      transformResponse: ({ result }) => result ?? [],
    }),
    updateDefaultSupportUser: builder.mutation({
      query: ({ slug, default_support_user_id }) => ({
        url: '/update_default_support_user',
        method: 'PUT',
        body: {
          slug: slug ?? '',
          default_support_user_id:
            default_support_user_id === undefined || default_support_user_id === ''
              ? null
              : default_support_user_id,
        },
      }),
      transformResponse: ({ result }) => result ?? {},
    }),
  }),
});

export const {
  useGetCheckTypesQuery,
  useLazyGetCheckTypesListQuery,
  useGetCheckGroupsQuery,
  useUpdateDefaultSupportUserMutation,
} = checkTypeApi;
